import create from 'zustand'

const useBooleanStore = create((set) => ({
  isToggled: false,
  toggleBoolean: () => set((state) => ({ isToggled: !state.isToggled }))
}))

export default useBooleanStore
